// extracted by mini-css-extract-plugin
export default {"friendsItem":"FriendsItem_friendsItem__o60wb","avatar":"FriendsItem_avatar__dZuiS","name":"FriendsItem_name__mvXqu","progressTime":"FriendsItem_progressTime__QKfT+"};